import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const Reset = (props) => {
    const token = props.match.params.token
    if (!token) {
        window.location.href = '/login'
    }
    const [changed, setChanged] = useState(false)
    const [reset, setReset] = useState({ password: '', repassword: '', error: '' })
    const [formerror, setFormError] = useState('')

    const handleChnage = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setReset(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const removeError = (e) => {
        setFormError('')
    }

    const getReset = async (e) => {
        e.preventDefault();
        if (reset.password === '') {
            setFormError('Please enter new password.')
        } else if(reset.password !== reset.repassword) {
            setFormError('Password and re-password should be same.')
        } else {
            await axios.post(
                localStorage.getItem('basurl') + '/reset', {
                token: token,
                password: reset.password
            }
            ).then(response => {
                setChanged(true)
            }).catch(error => {
                try {
                    setFormError(error.response.data.message);
                } catch (err) {
                    setFormError(error.message)
                }
                return;
            });
        }
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-center bg-br-primary ht-100v">
                <div className="login-wrapper wd-300 wd-xs-350 pd-25 pd-xs-40 bg-white rounded shadow-base">
                    <div className="signin-logo tx-center tx-28 tx-bold tx-inverse"><span className="tx-normal">[TV9 MOJO]</span></div>
                    <div className="tx-center mg-b-35">Mobile Friendly Solution</div>
                    {changed ?
                        <>
                            <p className="tx-14 tx-bold">
                                Your password has been changed successfully.
                            </p>
                            <br />
                            <NavLink to="/login">Go Back</NavLink>
                        </> :
                        <>
                            <span className="text-danger">{formerror}</span>
                            <form method="get" className="text-left form-validate" onSubmit={getReset}>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-email tx-16 lh-0 op-6"></i></span>
                                    <input name="password" type="password" className="form-control" placeholder="Please enter new password" onFocus={removeError} onChange={handleChnage} value={reset.password} autoComplete="off"/>
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-email tx-16 lh-0 op-6"></i></span>
                                    <input name="repassword" type="password" className="form-control" placeholder="Please re-enter new password" onFocus={removeError} onChange={handleChnage} value={reset.repassword} autoComplete="off"/>
                                </div>
                                <div className="form-group text-center"><button type="submit" className="btn btn-primary">Reset</button></div>
                            </form>
                        </>
                    }
                </div>
            </div>
        </>
    )
}
export default Reset;